import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=2d533ba6&scoped=true"
import script from "./NavigationHeader.vue?vue&type=script&lang=js"
export * from "./NavigationHeader.vue?vue&type=script&lang=js"
import style0 from "./NavigationHeader.vue?vue&type=style&index=0&id=2d533ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d533ba6",
  null
  
)

export default component.exports